module.exports = __webpack_public_path__ + "img/hook_KITO_HJK_2.b1b04f20.png";